import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import TrainingCertificationStaffPaymentEdit from './TrainingCertificationStaffPaymentEdit';

class TrainingCertificationStaffPaymentsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      training_id: this.props.training_id,
      updated: this.props.updated,
      training_certification_staff_payments: [],
    };

    //bind específico
    this.edit = this.edit.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.training_id !== 'undefined' && newProps.training_certification_staff_payments !== null) || (this.state.loaded === 1 && newProps.updated === 1)){
      this.setState({
        training_certification_staff_payments: newProps.training_certification_staff_payments,
        loaded: 1,
      });
    }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_id: this.state.staff_id,
      training_id: this.state.training_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificados/Colaborador', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Diárias do treinamento</h3>
  <hr/>
  {(this.state.training_certification_staff_payments === null || typeof this.state.training_certification_staff_payments === 'undefined') ?  <div><small><em>Nenhuma diária cadastrada.</em></small><hr/></div>
  :
  <div>
    {Object.keys(self.state.training_certification_staff_payments).map(function(training_certification_type) {
      return(
        <div>
          <h4>{training_certification_type}</h4>
          <hr/>
          <table className="table table-bordered table-stripped table-hover">
            <thead>
              <tr>
                <th className="col-md-2 text-center">Funcionário</th>
                <th className="text-center">Ida</th>
                <th className="text-center">Check-in</th>
                <th className="text-center">Início</th>
                <th className="text-center">Fim</th>
                <th className="text-center">Check-out</th>
                <th className="text-center">Volta</th>
                <th className="text-center">Qtd.<br/>Diárias</th>
                <th className="text-center">V. diária</th>
                <th className="text-center">V. Total</th>
                <th className="text-center"></th>
              </tr>
            </thead>
            <tbody id="suppliers-certifications">
              {Object.keys(self.state.training_certification_staff_payments[training_certification_type]).map(function(k) {
                return (
                  <TrainingCertificationStaffPaymentEdit training_certification_staff_payment_data={self.state.training_certification_staff_payments[training_certification_type][k]}  updateData={self.props.updateData} handleAlert={self.props.handleAlert} updated={self.props.updated} />
                );
              })}
            </tbody>
          </table>
          <hr/>
        </div>
      );
    })}
  </div>
  }
</div>
    );
  }
}

export default TrainingCertificationStaffPaymentsTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingCertificationStaffPaymentsTab.js